<div class="location-popup-div" id="{{id}}">
  <div class="location-popup-inner" title="{{endPointName}}">
    @if (hasWindData) {
      <div class="wind-pointer"
        [style.transform]="windDirectionRotation">
        <img src="assets/images/direction-icon.svg" [alt]="'wind_direction' | translate">
      </div>
    }
    @if (!hasWindData) {
      <div class="location-icon">
        <img alt="" src="assets/images/{{markerType}}.png">
      </div>
    }
    <div class="location-container">
      <h5 class="node-name-outer">
        <span class="node-name">{{endPointName}}</span>
      </h5>
      <div class="location-detail-outer">
        <div class="values-container">
          <div class="parameter-detail">
            <span [style]="'color: #'+parameterColor+';'" class="parameter-value">{{parameterValue}}<i
            [style]="'color: #'+parameterColor+';'" class="parameter-unit">{{parameterUnit}}</i></span>
          </div>
          @if (hasWindData) {
            <div class="wind-detail">
              <span class="wind-value">{{windSpeedDisplay}}<i class="wind-unit">{{windSpeedUnit}}</i></span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
